import React from 'react'
import { Modal } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import routes from 'src/routes'
import styled from 'styled-components'
import { COLORS } from '../../styles/theme'

const StyledModal = styled(Modal)`
  color: ${COLORS.primary};
  text-align: left;

  .modal-content {
    background-color: rgba(255, 255, 255, 0.9);
    border: none;
    border-radius: 0;
    padding: 24px 72px;
    margin-bottom: 24px;

    .modal-header {
      color: #ffad2c;
      border: none;
      .modal-title {
        font-size: 36px;
        font-weight: bold;
        font-style: italic;
      }
      button {
        font-size: 36px;
        opacity: 1;
        color: rgba(0, 0, 0, 0.55);
      }
    }
  }
  .divider {
    background: #002060;
    height: 4.5px;
  }
  .modal-body {
    padding-bottom: 36px;
    section {
      margin-bottom: 36px;
      h4 {
        font-style: italic;
        font-size: 23px;
        font-weight: bold;
      }
      .btn-container {
        padding: 20px 10px;
        border-bottom: 2px solid #002060;
      }
      button {
        border: 2px solid #ff9821;
        padding: 6px 12px;
        background: linear-gradient(#ff9821, #f83636);
        border-radius: 12px;
        color: white;
        &:hover {
          background: #ff9821;
        }
      }
    }
  }
  #refresh-btn {
    border: solid 1px ${COLORS.primary};
    background: #ffad2c;
    padding: 5px 10px;
    border-radius: 16px;
    margin: 36px auto;
    display: block;
  }
`

export default function LinkModal({ showModal, hideModal }) {
  const history = useHistory()

  const handleRedirect = (url) => {
    hideModal()
    history.push(url)
  }

  return (
    <StyledModal show={showModal} onHide={hideModal} size="xl" aria-labelledby="links-modal" centered>
      <Modal.Header closeButton>
        <Modal.Title>Navigation</Modal.Title>
      </Modal.Header>
      <div className="divider"></div>
      <Modal.Body>
        <section>
          <div className="btn-container">
            <h6>Click here to navigate to Auditorium !</h6>
            <button onClick={() => handleRedirect(routes.auditorium1)}>Auditorium</button>
          </div>
          <div className="btn-container">
            <h6>Click here to navigate to Gallery !</h6>
            <button onClick={() => handleRedirect(routes.onDemand)}>Gallery</button>
          </div>
        </section>
      </Modal.Body>
    </StyledModal>
  )
}
